<div class="card-body">
    <div id="apex-mixed-line-area-charts"></div>
</div>